export default "__VITE_ASSET__BZAQOm1O__"